export const receiverAddress = `Yuexiu District, Gangtou Street, No. 40, Meichaohui First Floor, File A1003 (left side of the main entrance) Feidehao International Freight Forwarding Limited Company`;
export const receiverAddressMandarin = `广州市越秀区岗头大街40号美潮汇一楼A1003档(正门入口处左手边)菲德昊国际货运代理有限`;
export const receiverPhone = `15218879830`;
